import React, { useEffect, useRef, useState } from "react";
import "bootstrap-daterangepicker/daterangepicker.css";
import CapexOpex from "./charts/Capex";
import Opex from "./charts/Opex";
import AssetChart from "./charts/AssetChart";
import AssetCondition from "./charts/AssetCondition";
import CapexVsOpex from "./charts/CapexOpex";
import {
  Card,
  CardHeader,
  CardBody,
  CardFooter,
} from "../../components/card/card";
import { matar } from "../../api";
import { downloadPDF } from "../../utils/helper";
import { useReactToPrint } from "react-to-print";
import { downloadExcel } from "../../utils/exporter";

function Dashboard() {
  const componentRef = useRef();
  const [value1, setValue1] = useState(100000);
  const [allCost, setAllCost] = useState([]);
  const [allWholeCost, setAllWholeCost] = useState([]);
  const [allFault, setAllFault] = useState([]);
  const [allData, setAllData] = useState([]);
  const [value2, setValue2] = useState(90000);
  const [slider1, setSlider1] = useState(40);
  const [slider2, setSlider2] = useState(60);
  const [assetGroup, setAssetGroup] = useState("All");
  const [asset, setAsset] = useState("All");
  const [criticality, setCriticality] = useState("All");
  const [strategy, setStrategy] = useState("All");
  const [valueRandom, setValueRandom] = useState(0);
  const getData = async () => {
    const result2 = await matar.getOverview({
      company: true,
    });
    if (result2.ok) {
      const body = await result2.json();
      const data = body.data;
      const cost_tmp = data.cost;
      // convert object to array
      const cost = Object.keys(cost_tmp).map((key) => {
        return {
          year: key,
          capex: parseInt(cost_tmp[key].capex),
          opex: parseInt(cost_tmp[key].opex),
          total_cost: parseInt(cost_tmp[key].total_cost),
        };
      });
      setAllWholeCost(cost);
      setAllCost(cost.filter((c) => c.year > 2024 && c.year < 2037));
      setAllData(data.datas);
      setAllFault(data.fault);
    }
  };

  useEffect(() => {
    setValueRandom(valueRandom + 1);
    getData();
  }, [asset, assetGroup, criticality, strategy]);
  const formatNumber = (num) => {
    if (num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return "";
  };

  const downloadHandler = useReactToPrint({
    content: () => componentRef.current,
  });

  const downloadExcelHandler = async () => {
    downloadExcel(allWholeCost, "overview");
  };

  return (
    <div>
      <div class="row">
        <div class="col-6">
          <h1 className="page-header">
            Overview <small>stats, overview & performance</small>
          </h1>

          <div className={"mb-1"}>
            <button
              onClick={downloadExcelHandler}
              className="btn btn-outline-theme btn-sm"
              style={{ marginRight: "4px" }}
            >
              <i className="fa fa-file-excel"></i> Download Excel
            </button>
            <button
              onClick={downloadHandler}
              className="btn btn-outline-theme btn-sm"
            >
              <i className="fa fa-file-pdf"></i> Download PDF
            </button>
          </div>
        </div>
        <div class="col-6"></div>
      </div>

      <div className="row" id="download-preview matar" ref={componentRef}>
        <div className={"print-header"}>
          <img src="/img/hamad_header.png" style={{ height: "80px" }} alt="" />
        </div>
        <div className="col-sm-12 mb-3 content matar">
          <Card className={"bg-blue-900 bg-opacity-80 border-blue card mb-3"}>
            <CardHeader>
              <h4>Budget Planner</h4>
              <div className="row">
                {allCost.map((cost, index) => (
                  <div className="col-2">
                    <div style={{ width: "100%" }} className={"mb-3"}>
                      <div className={"border p-1 small text-center"}>
                        {cost.year} Budget(USD)
                      </div>
                      <div
                        className={
                          "w-100 bg-theme border-theme text-center text-black text-bold"
                        }
                      >
                        $ {formatNumber(cost.total_cost)}
                      </div>
                    </div>
                  </div>
                ))}

                {/*<div className="col-4">*/}
                {/*<label htmlFor="">CAPEX vs OPEX Allocation</label>*/}
                {/*<input*/}
                {/*  value={slider2}*/}
                {/*  onChange={(e) => setSlider2(e.target.value)}*/}
                {/*  type="range"*/}
                {/*  readOnly={true}*/}
                {/*  disabled={true}*/}
                {/*  className="form-range"*/}
                {/*  min="0"*/}
                {/*  max="100"*/}
                {/*  step="5"*/}
                {/*  id="customRange3"*/}
                {/*/>*/}
                {/*<div className={"d-flex justify-content-between"}>*/}
                {/*  <small>CAPEX: {slider2}%</small>*/}
                {/*  <small>OPEX: {100 - slider2}%</small>*/}
                {/*</div>*/}
                {/*<div className={"d-flex justify-content-between"}>*/}
                {/*  <b>*/}
                {/*    {" "}*/}
                {/*    <small>*/}
                {/*      ${formatNumber(slider2 * value2 * 0.01)}*/}
                {/*    </small>{" "}*/}
                {/*  </b>*/}
                {/*  <b>*/}
                {/*    {" "}*/}
                {/*    <small>*/}
                {/*      ${formatNumber((100 - slider2) * value2 * 0.01)}*/}
                {/*    </small>*/}
                {/*  </b>*/}
                {/*</div>*/}
                {/*</div>*/}
              </div>
            </CardHeader>
            <CardBody>
              <div> CAPEX Plan</div>
              <CapexOpex changedValue={valueRandom} allData={allCost} />
            </CardBody>
            <CardFooter>OPEX Plan</CardFooter>
            <CardBody>
              <Opex changedValue={valueRandom} allData={allCost} />
            </CardBody>
          </Card>
        </div>
        <div className="col-sm-12  mb-3 page-break  matar">
          <Card
            className={
              "bg-blue-900 bg-opacity-80 border-blue card mb-3 content"
            }
          >
            <CardHeader>
              <h4>Asset Reaching End of Life</h4>
              <small className={" text-theme"} style={{ fontStyle: "italic" }}>
                This chart displays the number of assets projected to reach the
                end of their lifecycle each year.
              </small>
            </CardHeader>
            <CardBody>
              <AssetChart
                changedValue={valueRandom}
                allData={allFault}
                rawDatas={allData}
              />
              <small className={" text-theme"} style={{ fontStyle: "italic" }}>
                * Click on the chart to see the asset list
              </small>
            </CardBody>
          </Card>
        </div>
        <div className="col-sm-12  mb-3  page-break  matar">
          <Card
            className={
              "bg-blue-900 bg-opacity-80 border-blue card mb-3 content"
            }
          >
            <CardHeader>
              <h4>CAPEX vs OPEX</h4>
            </CardHeader>
            <CardBody>
              <CapexVsOpex changedValue={valueRandom} allData={allWholeCost} />
            </CardBody>
          </Card>
        </div>
        <div className="col-sm-6  mb-3">
          {/*<Card className={"bg-blue-900 bg-opacity-80 border-blue card mb-3"}>*/}
          {/*  <CardHeader>*/}
          {/*    <h4>Asset Condition</h4>*/}
          {/*  </CardHeader>*/}
          {/*  <CardBody>*/}
          {/*    <AssetCondition changedValue={valueRandom} />*/}
          {/*  </CardBody>*/}
          {/*</Card>*/}
        </div>
      </div>
    </div>
  );
}

export default Dashboard;
